import { Col, Divider, PageHeader, Row, Form, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import { Modal } from "shared/components";
import { UserTeamType } from "shared/enums/UserTeamType";
import { AddUserTeam } from "shared/service/StrmService";

interface AddMemberProps {
  visible: boolean;
  onSave: () => void;
  onCancel: () => void;
  teamId?: string;
}

const AddMemberForm: React.FC<AddMemberProps> = (props) => {
  const { visible, teamId, onCancel, onSave } = props;
  const { t } = useTranslation("radar");
  const [form] = Form.useForm();

  const onFinishForm = async () => {
    const values: any = form.getFieldsValue(true);
    await AddUserTeam({ teamId, ...values });
    onSave();
  };

  return (
    <Modal
      visible={visible}
      onOk={onFinishForm}
      closable={true}
      showCancelButton={false}
      onCancel={onCancel}
      width={"50%"}
      okText={t("pages.TeamManagement.add")}
    >
      <Row>
        <Col xs={24}>
          <PageHeader title={t("pages.TeamManagement.title")} />
        </Col>
      </Row>
      <Divider style={{ backgroundColor: "#E0E2E7" }} />
      <Form form={form} onFinish={onFinishForm} layout="vertical">
        <Row gutter={16}>
          <Col xs={12}>
            <Form.Item
              name={["user", "login"]}
              label={t("pages.TeamManagement.email")}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              name={["user", "userTeamType"]}
              label={t("pages.TeamManagement.permission")}
            >
              <Select style={{ textAlign: "start" }}>
                <Select.Option value={UserTeamType.Admin}>
                  {t("pages.TeamManagement.admin")}
                </Select.Option>
                <Select.Option value={UserTeamType.Manager}>
                  {t("pages.TeamManagement.manager")}
                </Select.Option>
                <Select.Option value={UserTeamType.Viewer}>
                  {t("pages.TeamManagement.viewer")}
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddMemberForm;
